/**
 * Os envios do Caso ao IW (NR-255): o que está na fila, o que gravou e o que foi recusado. O clique diz o desfecho da
 * primeira tentativa; o que acontece depois (reenvio, recusa, esgotou) só aparece aqui.
 */

import { queryOptions } from '@tanstack/react-query';
import type { IwOperationResponse } from '@anery/api-contracts';

import { requisitar } from '../../../shared/api/clienteHttp';
import { chavesDeCasos } from './casos';

export interface EnvioAoIw {
  readonly id: string;
  /** O que vai ao IW, pelo nome do membro (`CreatePatient`, `OpenAdmission`...). */
  readonly tipo: string;
  /** `Pending`, `Completed`, `Refused`, `Exhausted` — ou o que o back mandar de novo. */
  readonly estado: string;
  readonly pedidoEm: Date;
  readonly tentativas: number;
  readonly proximaTentativaEm: Date | null;
  readonly encerradoEm: Date | null;
  readonly camposRecusados: readonly string[];
  readonly motivo: string | null;
  readonly idNoIw: string | null;
  /** A recusa veio da plataforma, sem resposta do IW (sem status HTTP). */
  readonly recusadoPelaPlataforma: boolean;
}

const data = (valor: string | null | undefined): Date | null => (valor ? new Date(valor) : null);

export function mapearEnviosAoIw(resposta: readonly IwOperationResponse[]): EnvioAoIw[] {
  return resposta.map((e) => ({
    id: e.id,
    tipo: e.kind ?? '',
    estado: e.state ?? '',
    pedidoEm: new Date(e.requestedAt),
    tentativas: e.attempts,
    proximaTentativaEm: data(e.nextAttemptAt),
    encerradoEm: data(e.closedAt),
    camposRecusados: e.refusedFields ?? [],
    motivo: e.reason ?? null,
    idNoIw: e.iwId ?? null,
    recusadoPelaPlataforma: e.state === 'Refused' && e.lastHttpStatus == null,
  }));
}

/** `GET /casos/{id}/envios-iw`. Do mais recente ao mais antigo. */
export function opcoesDosEnviosAoIw(id: string) {
  return queryOptions({
    queryKey: chavesDeCasos.enviosAoIw(id),
    queryFn: ({ signal }) =>
      requisitar<IwOperationResponse[]>(`/casos/${encodeURIComponent(id)}/envios-iw`, { sinal: signal }).then(
        mapearEnviosAoIw,
      ),
    enabled: id !== '',
  });
}
